import axios from '@/libs/api.request'
import config from '@/config'

const privateCloudBaseUrl = config.basePrivateCloudUrl + '/cloud/api/v1/'

export const getPrivateCloudFloatingIp = (params) => {
  return axios.request({
    url: privateCloudBaseUrl + 'floating_ip/',
    needPrivateCloudProjectHeader: true,
    params: params,
    method: 'get'
  })
}

export const getPrivateCloudAllFloatingIp = (params) => {
  return axios.request({
    url: privateCloudBaseUrl + 'all_floating_ip_list/',
    needPrivateCloudProjectHeader: true,
    params: params,
    method: 'get'
  })
}

export const detailPrivateCloudFloatingIp = (id) => {
  return axios.request({
    url: privateCloudBaseUrl + 'floating_ip/' + id + '/',
    needPrivateCloudProjectHeader: true,
    method: 'get'
  })
}

export const changePrivateCloudFloatingIp = (data, id) => {
  let url = privateCloudBaseUrl + 'floating_ip/'
  let method = 'post'
  if (id) {
    url += id + '/'
    method = 'put'
  }
  return axios.request({
    url: url,
    data: data,
    needPrivateCloudProjectHeader: true,
    method: method
  })
}

export const deletePrivateCloudFloatingIp = (id) => {
  return axios.request({
    url: privateCloudBaseUrl + 'floating_ip/' + id + '/',
    needPrivateCloudProjectHeader: true,
    method: 'delete'
  })
}
